export default __webpack_public_path__ + "static/media/service_area_desk.83970620.png";